import {StyleSheet} from "aphrodite";

import {color, spacing} from "@khanacademy/wonder-blocks-tokens";
import {mediaQueries} from "@khan/shared-styles";

export const styles = StyleSheet.create({
    dropdown: {
        width: "100%",
        // HACK(yash): There are some inherited css properties on this page
        // which create a mismatch in expectations from wonder-blocks default
        // styling and what is rendered on the page. This attribute fixes that
        // by forcing the default wonder-blocks styles on the component.
        color: "initial",
    },
    error: {
        color: color.red,
    },
    compactRow: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: spacing.small_12,
        [mediaQueries.xsOrSmaller]: {
            gridTemplateColumns: "1fr",
            gap: 0,
        },
    },
    formField: {
        marginBottom: spacing.large_24,
    },
    compactFormField: {
        marginBottom: spacing.small_12,
    },
    fieldLabel: {
        marginBottom: spacing.small_12,
    },
});
